import Vue from "vue";
import VueRouter from "vue-router";
import AuthBasicLayout from "../views/Layout/AuthBasicLayout";
import '../plugins/firebase';
import firebase from 'firebase/compat/app';

// Auth pages
const PolicyKo = () => import("../views/Auth/PolicyKo.vue");
const PolicyEn = () => import("../views/Auth/PolicyEn.vue");
const PolicyZh = () => import("../views/Auth/PolicyZh.vue");
const PolicyJp = () => import("../views/Auth/PolicyJp.vue");
const Question = () => import("../views/Auth/Question.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: "Auth",
    redirect: "/pages/policy",
    component: AuthBasicLayout,
    children: [
      {
        path: "/pages/policy",
        name: "개인정보처리방침Ko",
        component: PolicyKo,
      },
      {
        path: "/pages/policy_en",
        name: "개인정보처리방침En",
        component: PolicyEn,
      },
      {
        path: "/pages/policy_zh",
        name: "개인정보처리방침Zh",
        component: PolicyZh,
      },
      {
        path: "/pages/policy_jp",
        name: "개인정보처리방침Jp",
        component: PolicyJp,
      },
      {
        path: "/pages/question",
        name: "문의사항",
        component: Question,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next();
      }
      else {
        next({ path: '/pages/auth/signin' });
        //next();
      }
    });
  }
  else {
    next();
  }
});

export default router;
